import { render } from "./SmartDashboard.vue?vue&type=template&id=b8500dba&scoped=true"
import script from "./SmartDashboard.vue?vue&type=script&lang=js"
export * from "./SmartDashboard.vue?vue&type=script&lang=js"

import "./SmartDashboard.vue?vue&type=style&index=0&id=b8500dba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8500dba"]])

export default __exports__